/**
 * UI 로케일 (RULES §1.17 UI_LOCALE). 빌드 상수 `__LOCALE__`(vite --mode en → 'en')이 기본이고 `setLocale` 로 바꾼다(`?lang=` 개발용).
 * 엔진·팩과 무관하다 — 팩 로케일은 `pack.locale` 이 따로 정한다(둘은 보통 같다).
 */
import type { Locale } from '../engine/alphabet';
import { en } from './en';
import { ko } from './ko';
import type { Strings } from './types';

export type { Strings } from './types';

const TABLE: Readonly<Record<Locale, Strings>> = { ko, en };

function buildLocale(): Locale {
  try {
    return typeof __LOCALE__ !== 'undefined' && __LOCALE__ === 'en' ? 'en' : 'ko';
  } catch {
    return 'ko';
  }
}

let current: Locale = buildLocale();

export function setLocale(locale: Locale): void {
  current = locale;
}

export function currentLocale(): Locale {
  return current;
}

/** 현재 로케일의 문자열 표 — 호출 시점에 읽는다(setLocale 뒤 갱신) */
export function t(): Strings {
  return TABLE[current];
}
